import { getError } from "@/utils/helpers";
import ClientService from "@/services/ClientService";

export const namespaced = true;

export const state = {
  clients: [],
  loading: false,
  error: null,
};

export const mutations = {
  SET_CLIENTS(state, clients) {
    state.clients = clients;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

export const actions = {
  getClients({ commit }) {
    commit("SET_LOADING", true);

    ClientService.getClients()
      .then((response) => {
        commit("SET_CLIENTS", response.data.data);
      })
      .catch((error) => {
        commit("SET_LOADING", false);
        commit("SET_ERROR", getError(error));
      })
      .finally(() => {
        commit("SET_LOADING", false);
      });
  },
};
export const getters = {
  clients: (state) => {
    return state.clients;
  },
  loading: (state) => {
    return state.loading;
  },
  error: (state) => {
    return state.error;
  },
};
